// ============================================================================
// CONTRACT DATA — Contrato de Prestação de Serviços Advocatícios
// Sincronizado com o mestre do Firestore (contract_templates/master_v8) em
// 12/08/2026. Ver CONSTITUICAO_REGRAS.SH Art. 337 (runbook local<->nuvem),
// Art. 342-346 (correções de conteúdo, XSS, fechamento), Art. 349 (análise
// cruzada de citações legais) e Art. 351-352 (preâmbulo, Cláusula 14.4,
// item de Vigência).
//
// GÊNERO DO TERMO INSTITUCIONAL ("a parte CONTRATANTE"/"CONTRATADA") — FIXO,
// NÃO VARIÁVEL. Ver CONSTITUICAO_REGRAS.SH Art. 381 para a análise completa.
// Resumo: `formData.parties` é ARRAY (múltiplos contratantes reais, já
// suportados na UI) — um sistema de artigo variável (o/a) exigiria resolver
// singular-M/singular-F/plural-M/plural-misto, e o caso de grupo misto cai
// no mesmo problema de linguagem inclusiva que a convenção fixa (singular e
// feminino, independente de gênero/pluralidade) existe para evitar. Isto é
// restrição técnica real, não escolha de estilo — não confundir com a
// Declaração, que é variável porque nunca tem mais de 1 declarante.
// ============================================================================

export const STATIC_CONTENT = {
    header: '<div class="text-center pb-4 mb-8"><h1 class="contract-title text-2xl font-black text-brand-blue uppercase mb-2">CONTRATO DE PRESTAÇÃO DE SERVIÇOS ADVOCATÍCIOS E HONORÁRIOS</h1></div>',
    footer: '<div class="text-center text-sm text-gray-500 mt-12">Curitiba, <strong>[[DATA_EXTENSO]]</strong>.</div>'
};

export const TAXONOMY_TREE = {
    "Civil": { 
        label: "Cível / Empresarial", color: "blue", objects: [
            { id: "CIV_CONHECIMENTO", label: "Ação de Conhecimento (Indenizatória/Cobrança)", suggestedFee: 3537.08 },
            { id: "CIV_EXECUCAO", label: "Ação de Execução de Título Extrajudicial", suggestedFee: 3537.08 },
            { id: "CIV_TUTELA", label: "Tutela de Urgência / Cautelar", suggestedFee: 3537.08 },
            { id: "CIV_RECURSO", label: "Interposição de Recursos Cíveis", suggestedFee: 4610.13 },
            { id: "CIV_CONTESTACAO", label: "Defesa / Contestação", suggestedFee: 3537.08 },
            { id: "CIV_EMBARGOS", label: "Embargos à Execução / Exceção", suggestedFee: 3537.08 },
            { id: "CIV_CONTRATOS", label: "Elaboração e Revisão de Contratos (Consultivo)", suggestedFee: 3841.77 },
            { id: "CIV_DUE_DILIGENCE", label: "Due Diligence / Auditoria Empresarial", suggestedFee: 4636.60 }
        ]
    },
    "Penal": { 
        label: "Criminal e Execução", color: "red", objects: [
            { id: "PEN_INQUERITO", label: "Acompanhamento em Inquérito Policial (IP/PIC)", suggestedFee: 3378.11 },
            { id: "PEN_FLAGRANTE", label: "Acompanhamento de Prisão em Flagrante / Custódia", suggestedFee: 2768.73 },
            { id: "PEN_QUEIXA", label: "Oferecimento de Queixa-Crime", suggestedFee: 5073.79 },
            { id: "PEN_ASSISTENCIA", label: "Atuação como Assistente de Acusação", suggestedFee: 4610.13 },
            { id: "PEN_DEFESA_ACAO", label: "Defesa Processual em Ação Penal (Resposta/Memoriais)", suggestedFee: 4546.50 },
            { id: "PEN_HC", label: "Impetração de Habeas Corpus", suggestedFee: 5689.80 },
            { id: "PEN_JURI", label: "Defesa em Plenário do Tribunal do Júri", suggestedFee: 7994.86 },
            { id: "PEN_RECURSO", label: "Interposição de Recursos Penais", suggestedFee: 4610.13 },
            { id: "PEN_EXECUCAO", label: "Acompanhamento de Execução Penal (Progressão/Livramento)", suggestedFee: 3384.73 }
        ]
    },
    "Trabalho": {
        label: "Trabalhista", color: "cyan", objects: [
            { id: "TRAB_RECLAMACAO", label: "Propositura de Reclamação Trabalhista", suggestedFee: 2305.06 },
            { id: "TRAB_RESCISAO", label: "Ação de Rescisão Indireta", suggestedFee: 2305.06 },
            { id: "TRAB_DEFESA", label: "Defesa / Contestação Trabalhista", suggestedFee: 2305.06 },
            { id: "TRAB_AUDITORIA", label: "Auditoria e Compliance Trabalhista (Preventivo)", suggestedFee: 4636.60 }
        ]
    },
    "Previdenciario": {
        label: "Previdenciário", color: "amber", objects: [
            { id: "PREV_REQUERIMENTO", label: "Requerimento Administrativo (INSS)", suggestedFee: 1841.40 },
            { id: "PREV_ACAO_CONCESSAO", label: "Ação Judicial de Concessão / Restabelecimento", suggestedFee: 6921.81 },
            { id: "PREV_ACAO_REVISAO", label: "Ação Judicial de Revisão de Benefício", suggestedFee: 6921.81 },
            { id: "PREV_PLANEJAMENTO", label: "Planejamento Previdenciário (Consultivo)", suggestedFee: 1841.40 }
        ]
    },
    "Administrativo": {
        label: "Administrativo e Tributário", color: "slate", objects: [
            { id: "ADM_MANDADO_SEG", label: "Impetração de Mandado de Segurança", suggestedFee: 5378.48 },
            { id: "ADM_ANULATORIA", label: "Ação Anulatória / Repetição de Indébito", suggestedFee: 5378.48 },
            { id: "ADM_DEFESA_PAD", label: "Defesa em Processo Administrativo Disciplinar (PAD)", suggestedFee: 3841.77 },
            { id: "ADM_DEFESA_AUTO", label: "Defesa contra Auto de Infração / Multa", suggestedFee: 3073.42 },
            { id: "ADM_PLANEJAMENTO", label: "Consultoria e Planejamento Tributário", suggestedFee: 2921.07 }
        ]
    },
    "Familia": {
        label: "Família e Sucessões", color: "purple", objects: [
            { id: "FAM_DIVORCIO", label: "Ação de Divórcio / Dissolução de União Estável", suggestedFee: 4610.13 },
            { id: "FAM_ALIMENTOS", label: "Ação de Alimentos / Guarda / Visitas", suggestedFee: 3841.77 },
            { id: "FAM_INTERDICAO", label: "Ação de Interdição / Curatela", suggestedFee: 5378.48 },
            { id: "FAM_INVENTARIO", label: "Inventário e Partilha (Judicial ou Extrajudicial)", suggestedFee: 6146.84 },
            { id: "FAM_PLANEJAMENTO", label: "Planejamento Sucessório / Pacto Antenupcial", suggestedFee: 5418.22 }
        ]
    }
};

export const HONORARIOS_LIST = [
    { id: "hon_fixo", label: "Pró-Labore (Fixo Inicial)", type: "Fixo" },
    { id: "hon_exito", label: "Ad Exitum (Risco / % ao final)", type: "Risco" },
    { id: "hon_quota_litis", label: "Quota Litis (Risco Integral)", type: "Risco" },
    { id: "hon_partido", label: "Partido / Mensada (Recorrente)", type: "Recorrente" },
    { id: "hon_hora", label: "Hora Técnica (Consultivo)", type: "Fixo" }
];

export const CLAUSE_LIBRARY = [
    {
        "id": "preambulo",
        "title": "PREÂMBULO",
        "type": "text",
        "tags": [
            "Universal"
        ],
        "content": "<p>Considerando que a parte <strong>CONTRATANTE</strong> busca a expertise jurídica e a representação técnica especializada da parte <strong>CONTRATADA</strong> para a defesa de seus interesses;</p><p>Considerando que a advocacia é função essencial e indispensável à administração da justiça, nos estritos termos do <strong>art. 133 da Constituição Federal de 1988</strong>;</p><p>As partes, devidamente qualificadas na [[REF_CLAUSE:cl_new_1771331843388]], firmam o presente contrato de prestação de serviços advocatícios com o propósito de formalizar os termos da relação profissional, assegurando total transparência, clareza nas obrigações recíprocas e a busca pela excelência na prestação dos serviços.</p><p>Para fins de padronização, fluidez de leitura e segurança contratual, este instrumento adotará a expressão institucional \"a parte <strong>CONTRATANTE</strong>\" para referir-se ao polo tomador dos serviços, independentemente do seu gênero (masculino ou feminino), da sua natureza (pessoa física ou pessoa jurídica) ou de sua pluralidade (cotitularidade contratual), qualificado(s) na Cláusula 1ª deste instrumento. De igual modo, a expressão institucional \"a parte <strong>CONTRATADA</strong>\" designará o polo prestador dos serviços, abrangendo a sociedade de advogados, seu titular e eventuais advogados associados ou parceiros qualificados na Cláusula 1ª. Sendo assim, toda a concordância verbal e nominal das cláusulas a seguir obedecerá estritamente a esta regra (singular e feminino).</p><p>Ressalva-se que a padronização de gênero gramatical aqui adotada tem finalidade exclusivamente técnica de uniformização redacional, não refletindo qualquer declaração sobre o gênero ou natureza das partes, assegurando-se a validade do instrumento independentemente de eventuais usos gramaticais divergentes da concordância tradicional.</p>"
    },
    {
        "id": "cl_new_1771331843388",
        "title": "DAS PARTES",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771331843388_item_1",
                "type": "sub_clause",
                "content": "[[ROTULO_CONTRATADO]] [[QUALIFICACAO_CONTRATADO]]",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331843388_item_2",
                "type": "sub_clause",
                "content": "[[ROTULO_CONTRATANTE]] [[QUALIFICACAO_COMPLETA]]",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331843388_item_3",
                "type": "sub_clause",
                "content": "[[QUALIFICACAO_COMPLETA_DE_TODOS]]",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771331845468",
        "title": "DO OBJETO E ESCOPO DOS SERVIÇOS",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771331845468_item_1",
                "type": "sub_clause",
                "content": "O presente contrato tem como objeto a prestação de serviços advocatícios especializados pela parte <strong>CONTRATADA</strong> em favor da parte <strong>CONTRATANTE</strong>, consistindo na seguinte atuação principal:<br>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331845468_item_2",
                "type": "sub_clause",
                "content": "Atuação na área do Direito [[RAMO_DIREITO]], figurando a parte <strong>CONTRATANTE</strong> como [[POSICAO_CLIENTE]], especificamente para: [[SERVICOS_CONTRATADOS]].",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331845468_item_3",
                "type": "sub_clause",
                "content": "<p><strong>Serviços Abrangentes</strong>: os serviços remunerados pelos honorários pactuados neste instrumento limitam-se, de forma taxativa, à completa representação da parte <strong>CONTRATANTE</strong>, compreendendo os seguintes atos:</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331845468_item_4",
                "type": "sub_clause",
                "content": "<p><strong>Atuação Contenciosa:</strong></p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331845468_item_5",
                "type": "sub_clause",
                "content": "<p>acompanhamento e condução integral do processo, incluindo a elaboração de todas as peças processuais necessárias, como petições, manifestações e recursos ordinários (excluindo-se recursos para os Tribunais Superiores, STJ e STF);</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_6",
                "type": "sub_clause",
                "content": "<p>participação em audiências de conciliação, instrução e julgamento;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_7",
                "type": "sub_clause",
                "content": "<p>realização de sustentações orais perante os Tribunais de Justiça;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_8",
                "type": "sub_clause",
                "content": "<p>realização de reuniões, análise de documentos e diligências pertinentes e necessárias ao caso;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_9",
                "type": "sub_clause",
                "content": "<p>envio de notificações e comunicações extrajudiciais, quando aplicável;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_10",
                "type": "sub_clause",
                "content": "<p>assessoria e consultoria jurídica contínua, estritamente sobre o objeto do processo;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_11",
                "type": "sub_clause",
                "content": "<p><strong>Atuação Consultiva/Extrajudicial:</strong></p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331845468_item_12",
                "type": "sub_clause",
                "content": "<p>análise da documentação e das informações fornecidas pela parte <strong>CONTRATANTE</strong> sobre o objeto do serviço;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_13",
                "type": "sub_clause",
                "content": "<p>realização de reuniões (presenciais ou virtuais) para discussão e alinhamento estratégico;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_14",
                "type": "sub_clause",
                "content": "<p>elaboração e/ou revisão dos documentos jurídicos especificados no objeto deste contrato;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_15",
                "type": "sub_clause",
                "content": "<p>orientação jurídica verbal ou escrita sobre as questões diretamente relacionadas ao objeto contratado.</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_16",
                "type": "sub_clause",
                "content": "<p><strong>Serviços Excepcionais/Adicionais</strong>: qualquer serviço que não esteja expressamente descrito no item anterior será considerado excepcional, incluindo, mas não se limitando a:</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331845468_item_17",
                "type": "sub_clause",
                "content": "<p><strong>Atuação Contenciosa:</strong></p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331845468_item_18",
                "type": "sub_clause",
                "content": "<p>propositura de ações conexas não inicialmente previstas;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_19",
                "type": "sub_clause",
                "content": "<p>recursos para Tribunais Superiores (STJ e STF) e as respectivas sustentações orais e atos correlatos nestas instâncias superiores;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_20",
                "type": "sub_clause",
                "content": "<p>atuação em processos incidentais ou em qualquer outra ação judicial ou extrajudicial que surja no decorrer da demanda principal;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_21",
                "type": "sub_clause",
                "content": "<p><strong>Atuação Consultiva/Extrajudicial:</strong></p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331845468_item_22",
                "type": "sub_clause",
                "content": "<p>atuação em qualquer processo judicial ou administrativo, mesmo que decorrente do objeto consultivo;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_23",
                "type": "sub_clause",
                "content": "<p>representação da parte <strong>CONTRATANTE</strong> em negociações ou mediações com terceiros;</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_24",
                "type": "sub_clause",
                "content": "<p>elaboração de novos documentos ou pareceres não previstos no objeto inicial.</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331845468_item_25",
                "type": "sub_clause",
                "content": "<p>Tais serviços serão objeto de novo ajuste de honorários e formalização por aditivo contratual.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331845468_item_26",
                "type": "sub_clause",
                "content": "<p><strong>Definição de Proveito Econômico para Fins Contratuais</strong>: para todos os fins deste contrato, especialmente para o cálculo de honorários de êxito e do ressarcimento de despesas de desmobilização previsto na <strong>[[REF_CLAUSE:cl_new_1771332194792]]</strong>, o termo \"Proveito Econômico\" terá a seguinte definição:</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331845468_item_27",
                "type": "sub_clause",
                "content": "<p><strong>Quando a parte CONTRATANTE for Autora:</strong> corresponderá ao valor bruto total da condenação, do acordo ou do benefício obtido, incluindo principal, juros, multas e correção monetária, sem quaisquer descontos.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331845468_item_28",
                "type": "sub_clause",
                "content": "<p><strong>Quando a parte CONTRATANTE for Ré:</strong> corresponderá ao valor total que a parte <strong>CONTRATANTE</strong> deixar de pagar em virtude da improcedência (total ou parcial) dos pedidos da parte contrária. Ou seja, a base de cálculo será a economia efetivamente gerada pela atuação da parte <strong>CONTRATADA</strong>.</p>",
                "condition": "ALWAYS",
                "level": 1
            }
        ]
    },
    {
        "id": "cl_new_1771331847084",
        "title": "DOS HONORÁRIOS E FORMAS DE PAGAMENTO",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771331847084_item_fixo",
                "type": "sub_clause",
                "content": "<p>Pela prestação dos serviços ora contratados, a parte <strong>CONTRATANTE</strong> pagará a quantia líquida e certa de [[VALOR_HONORARIOS]].</p>",
                "requiredHonorarios": [
                    "hon_fixo"
                ],
                "matchRule": "ANY",
                "level": 0,
                "excludedWhenAllSelected": [
                    "hon_fixo",
                    "hon_exito"
                ]
            },
            {
                "id": "cl_new_1771331847084_item_exito",
                "type": "sub_clause",
                "content": "<p>Considerando a modalidade de risco assumida, a parte <strong>CONTRATANTE</strong> pagará o percentual de [[PERCENTUAL_EXITO]].</p>",
                "requiredHonorarios": [
                    "hon_exito",
                    "hon_quota_litis"
                ],
                "matchRule": "ANY",
                "level": 0,
                "excludedWhenAllSelected": [
                    "hon_fixo",
                    "hon_exito"
                ]
            },
            {
                "id": "cl_new_1771331847084_item_misto",
                "type": "sub_clause",
                "content": "<p>Pelos serviços prestados, a remuneração englobará:</p><p>a) Pró-labore: [[VALOR_HONORARIOS]].</p><p>b) <em>Ad Exitum</em> (Êxito): [[PERCENTUAL_EXITO]].</p>",
                "requiredHonorarios": [
                    "hon_fixo",
                    "hon_exito"
                ],
                "matchRule": "ALL",
                "level": 0
            },
            {
                "id": "cl_new_1771331847084_item_partido",
                "type": "sub_clause",
                "content": "<p>Pela modalidade de honorários recorrentes (partido/mensalidade), a parte <strong>CONTRATANTE</strong> pagará a quantia mensal de [[VALOR_HONORARIOS]], devida enquanto perdurar a prestação de serviços, independentemente do volume de demandas no período.</p>",
                "requiredHonorarios": [
                    "hon_partido"
                ],
                "matchRule": "ANY",
                "level": 0
            },
            {
                "id": "cl_new_1771331847084_item_hora",
                "type": "sub_clause",
                "content": "<p>Pela modalidade de honorários por hora técnica, a parte <strong>CONTRATANTE</strong> pagará o valor de [[VALOR_HONORARIOS]] por hora de trabalho efetivamente dedicada, apurado e cobrado conforme os registros de horas da parte <strong>CONTRATADA</strong>.</p>",
                "requiredHonorarios": [
                    "hon_hora"
                ],
                "matchRule": "ANY",
                "level": 0
            },
            {
                "id": "cl_new_1771331847084_item_1",
                "type": "sub_clause",
                "content": "<p>Todas as despesas processuais correm por conta da parte <strong>CONTRATANTE</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331847084_item_2",
                "type": "sub_clause",
                "content": "<p><strong>Conformidade com a Tabela da OAB</strong>: as partes declaram que os honorários aqui pactuados foram definidos em observância aos princípios da moderação e da proporcionalidade, respeitando os valores mínimos estabelecidos na Tabela de Honorários da OAB/PR vigente na data da celebração deste contrato.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331847084_item_3",
                "type": "sub_clause",
                "content": "<p><strong>Inadimplemento</strong>: o atraso no pagamento de qualquer parcela de honorários acordada, por período superior a <strong>1 (um) dia</strong>, implicará em multa de <strong>2% (dois por cento)</strong> sobre o valor devido, nos termos do art. 52, § 1º, da Lei n. 8.078/1990 (Código de Defesa do Consumidor), juros de <strong>1% (um por cento)</strong> ao mês e correção monetária pelo IPCA.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331847084_item_4",
                "type": "sub_clause",
                "content": "<p><strong>Honorários de Cobrança (Repasse de Custos):</strong> Caso a inadimplência supere 30 (trinta) dias e exija a mobilização da estrutura do escritório para cobrança (judicial ou extrajudicial), serão acrescidos ao débito o percentual de <strong>10% (dez por cento)</strong> a título de ressarcimento das despesas operacionais e honorários advocatícios de cobrança efetivamente incorridos, nos termos dos arts. 389 e 395 da Lei n. 10.406/2002 (Código Civil), observado o limite do mesmo diploma consumerista quando aplicável.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331847084_item_5",
                "type": "sub_clause",
                "content": "<p><strong>Cláusula <em>Anti-Bypass</em> (Vedação ao Acordo Clandestino):</strong> Fica expressamente pactuado que a realização de qualquer acordo, transação ou composição amigável diretamente entre a parte <strong>CONTRATANTE</strong> e a parte contrária, realizado sem a participação ou ciência prévia da parte <strong>CONTRATADA</strong>, <strong>não eximirá a parte CONTRATANTE do pagamento integral dos honorários de êxito (<em>Ad Exitum</em>) aqui contratados</strong>.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331847084_item_6",
                "type": "sub_clause",
                "content": "<p>Nesta hipótese, a base de cálculo dos honorários incidirá sobre o valor total do benefício econômico obtido no acordo ou, na impossibilidade de aferição exata, sobre o <strong>valor atualizado da causa</strong>, considerando-se o serviço advocatício como <strong>integralmente prestado</strong> para fins de vencimento antecipado da dívida (Teoria do Adimplemento Substancial).</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331847084_item_7",
                "type": "sub_clause",
                "content": "<p><strong>Autorização para Dedução</strong>: a parte <strong>CONTRATANTE</strong>, desde já, autoriza a parte <strong>CONTRATADA</strong> a receber os valores da condenação ou acordo diretamente, por meio de alvará judicial ou outro meio legal, e a deduzir do montante recebido os valores devidos a título de honorários de êxito, repassando o valor líquido à parte <strong>CONTRATANTE</strong> no prazo máximo de <strong>5 (cinco) dias úteis</strong>, mediante prestação de contas detalhada.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331847084_item_8",
                "type": "sub_clause",
                "content": "<p><strong>Honorários de Sucumbência</strong>: os honorários contratuais (de êxito ou de qualquer outra natureza) não se confundem com as verbas de sucumbência, que pertencem exclusivamente à parte <strong>CONTRATADA</strong>, conforme art. 23 da Lei n. 8.906/1994 (Estatuto da Advocacia). Os honorários de sucumbência são um valor extra que a parte perdedora no processo é condenada a pagar ao advogado da parte vencedora. Esse valor é um \"prêmio\" pelo bom trabalho técnico e, por lei, pertence ao advogado, não se confundindo com os honorários diretamente contratados com a parte <strong>CONTRATANTE</strong>. Para sua clareza, a seguir, exemplos de como funciona:</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331847084_item_9",
                "type": "sub_clause",
                "content": "<p><strong>Cenários para a parte CONTRATANTE como Autora da Ação:</strong></p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331847084_item_10",
                "type": "sub_clause",
                "content": "<p><strong>Improcedência Total da Ação (Perda Total para a Autora):</strong> Se a ação for julgada totalmente improcedente, o juízo condenará a parte <strong>CONTRATANTE</strong> a pagar os honorários de sucumbência ao advogado da parte contrária (entre 10% e 20% sobre o valor da causa). Esse valor será um custo adicional para a parte <strong>CONTRATANTE</strong>.</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331847084_item_11",
                "type": "sub_clause",
                "content": "<p><strong>Procedência Parcial da Ação (Sucumbência Recíproca):</strong> Se a parte <strong>CONTRATANTE</strong> obtiver êxito em apenas parte do que pediu, o juízo dividirá a sucumbência. A parte <strong>CONTRATANTE</strong> pagará sucumbência sobre a parte que perdeu, e a parte contrária pagará sucumbência sobre a parte do pedido que foi negada. </p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331847084_item_12",
                "type": "sub_clause",
                "content": "<p><strong>Procedência Total da Ação (Vitória Total para a Autora):</strong> Se a ação for julgada totalmente procedente, a parte contrária será condenada a pagar o valor da causa e, adicionalmente, os honorários de sucumbência diretamente para a parte <strong>CONTRATADA</strong>.</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331847084_item_13",
                "type": "sub_clause",
                "content": "<p><strong>Cenários para a parte CONTRATANTE como Ré na Ação:</strong></p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771331847084_item_14",
                "type": "sub_clause",
                "content": "<p><strong>Improcedência Total da Ação (Vitória Total para a Ré):</strong> Se a ação movida contra a parte <strong>CONTRATANTE</strong> for julgada totalmente improcedente, a parte autora será condenada a pagar os honorários de sucumbência diretamente para a parte <strong>CONTRATADA</strong>.</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331847084_item_15",
                "type": "sub_clause",
                "content": "<p><strong>Procedência Parcial da Ação (Sucumbência Recíproca):</strong> Se a parte <strong>CONTRATANTE</strong> for condenada a pagar apenas parte do que foi pedido pelo autor, o juízo dividirá a sucumbência. A parte <strong>CONTRATANTE</strong> pagará sucumbência sobre a parte em que foi condenada, e a parte autora pagará sucumbência sobre a parte do pedido que foi negada.</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331847084_item_16",
                "type": "sub_clause",
                "content": "<p><strong>Procedência Total da Ação (Derrota Total para a Ré):</strong> Se a parte <strong>CONTRATANTE</strong> for condenada a pagar tudo o que o autor pediu, ela também será condenada a pagar os honorários de sucumbência ao advogado do autor.</p>",
                "condition": "ALWAYS",
                "level": 2
            },
            {
                "id": "cl_new_1771331847084_item_17",
                "type": "sub_clause",
                "content": "<p><strong>Se a parte CONTRATANTE Tiver Justiça Gratuita (Hipossuficiência):</strong> se a parte <strong>CONTRATANTE</strong> for beneficiária da Justiça Gratuita e perder o processo (total ou parcialmente), o juízo ainda assim irá condená-la a pagar os honorários de sucumbência. A grande diferença é que esta dívida fica com a <strong>cobrança suspensa por 5 (cinco) anos</strong>. A outra parte só poderá cobrar este valor se, dentro desses 5 (cinco) anos, provar que a situação financeira da parte <strong>CONTRATANTE</strong> mudou e ela pode pagar. Se passarem os 5 (cinco) anos e não houver essa prova, a dívida \"caduca\" e não pode mais ser cobrada.</p>",
                "condition": "ALWAYS",
                "level": 2
            }
        ]
    },
    {
        "id": "cl_new_1771331848012",
        "title": "DO REEMBOLSO DE DESPESAS PROCESSUAIS E EXTRAJUDICIAIS",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771331848012_item_1",
                "type": "sub_clause",
                "content": "<p>Além dos honorários estabelecidos na <strong>[[REF_CLAUSE:cl_new_1771331847084]]</strong>, a parte <strong>CONTRATANTE</strong> reembolsará a parte <strong>CONTRATADA</strong> por todas e quaisquer despesas comprovadamente realizadas em função da prestação dos serviços objeto deste contrato.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331848012_item_2",
                "type": "sub_clause",
                "content": "<p>As despesas serão apresentadas à parte <strong>CONTRATANTE</strong> mediante demonstrativo detalhado e comprovação (recibos, notas fiscais), e deverão ser reembolsadas no prazo máximo de <strong>5 (cinco) dias úteis</strong> contados da data da solicitação de reembolso.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331848012_item_3",
                "type": "sub_clause",
                "content": "<p>A não observância do prazo de reembolso implicará na incidência de multa de <strong>2% (dois por cento)</strong>, nos termos do art. 52, § 1º, da Lei n. 8.078/1990 (Código de Defesa do Consumidor), e juros de <strong>1% (um por cento)</strong> ao mês e correção monetária pelo IPCA.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331848012_item_4",
                "type": "sub_clause",
                "content": "<p>As despesas com deslocamentos (aéreos ou terrestres), hospedagem e alimentação para a prática de atos processuais ou diligências necessárias fora da Comarca de Curitiba/PR, ou que excedam um raio de <strong>50 (cinquenta) quilômetros</strong> da sede do escritório, dependerão de prévia e expressa autorização da parte <strong>CONTRATANTE</strong>, mediante apresentação de orçamento prévio.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771331848012_item_5",
                "type": "sub_clause",
                "content": "<p>As despesas de deslocamento terrestre, quando realizado com veículo particular da parte <strong>CONTRATADA</strong>, serão calculadas com base no valor do quilômetro rodado estipulado na Tabela de Honorários e Diligências da OAB/PR vigente na data da efetiva realização da despesa, acrescido de eventuais custos de pedágio, que deverão ser comprovados.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771332175674",
        "title": "DAS OBRIGAÇÕES E RESPONSABILIDADES DAS PARTES",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771332175674_item_1",
                "type": "sub_clause",
                "content": "<p><strong>Obrigações da parte CONTRATADA:</strong></p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332175674_item_2",
                "type": "sub_clause",
                "content": "<p>atuar com a máxima diligência, zelo, probidade e técnica jurídica, empregando todos os esforços necessários à defesa dos interesses da parte <strong>CONTRATANTE</strong>, em conformidade com as leis, o <strong>Código de Ética e Disciplina da OAB</strong> e as melhores práticas da advocacia. </p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_meio_resultado",
                "type": "sub_clause",
                "condition": "ALWAYS",
                "level": 1,
                "content": "<p><strong>Obrigação de Meio, Não de Resultado</strong>: a prestação dos serviços advocatícios constitui obrigação de meio, e não de resultado. A parte <strong>CONTRATADA</strong> compromete-se a empregar toda a diligência, técnica e conhecimento jurídico ao seu alcance na defesa dos interesses da parte <strong>CONTRATANTE</strong>, sem que o insucesso da demanda, por si só, configure inadimplemento contratual, uma vez que o desfecho do processo não está sob o controle da parte <strong>CONTRATADA</strong>, dependendo de fatores alheios à sua atuação, como a convicção do julgador, a conduta da parte contrária e a álea processual inerente a qualquer litígio. Nenhuma estimativa de êxito, prognóstico ou expectativa de resultado eventualmente comunicada pela parte <strong>CONTRATADA</strong> à parte <strong>CONTRATANTE</strong>, verbalmente ou por escrito, constitui garantia, promessa ou compromisso vinculante quanto ao desfecho da causa.</p>"
            },
            {
                "id": "cl_new_1771332175674_item_3",
                "type": "sub_clause",
                "content": "<p>manter a parte <strong>CONTRATANTE</strong> informada de forma clara e transparente sobre o andamento do processo, os atos processuais relevantes, as decisões judiciais e as estratégias adotadas, utilizando os meios de comunicação previamente acordados (e-mail, telefone/WhatsApp do escritório), observando os horários de atendimento.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_4",
                "type": "sub_clause",
                "content": "<p>obter o <strong>consentimento inequívoco e informado</strong> da parte <strong>CONTRATANTE</strong> para a prática de atos processuais que impliquem em disposição de direitos, transação, renúncia, reconhecimento de pedidos, celebração de acordos, ou que possuam impacto financeiro ou estratégico significativo, conforme detalhado no <strong>Protocolo de Consentimento Informado [[REF_CLAUSE:cl_new_1771332176602]].</strong></p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_5",
                "type": "sub_clause",
                "content": "<p>prestar contas detalhadas dos valores recebidos da parte <strong>CONTRATANTE</strong> e das despesas efetuadas em nome da causa, quando aplicável, bem como guardar absoluto sigilo e confidencialidade sobre todas as informações, documentos e fatos a ela confiados pela parte <strong>CONTRATANTE</strong>, observando o sigilo profissional imposto por lei.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_sigilo_excecao",
                "type": "sub_clause",
                "condition": "ALWAYS",
                "level": 1,
                "content": "<p><strong>Limites do Sigilo Profissional</strong>: o dever de sigilo profissional da parte <strong>CONTRATADA</strong>, embora amplo, comporta a exceção prevista nos arts. 25 e 26 do Código de Ética e Disciplina da OAB (Resolução n. 02/2015 do Conselho Federal da OAB): caso a parte <strong>CONTRATANTE</strong> comunique à parte <strong>CONTRATADA</strong>, no curso da relação, a intenção de praticar crime futuro, cessa nessa exata medida o dever de sigilo, ficando a parte <strong>CONTRATADA</strong> autorizada e, quando exigido por lei, obrigada a adotar as providências cabíveis para evitar sua consumação, inclusive a comunicação às autoridades competentes.</p>"
            },
            {
                "id": "cl_new_1771332175674_item_6",
                "type": "sub_clause",
                "content": "<p>restituir à parte <strong>CONTRATANTE</strong>, ao final do processo ou da rescisão, os documentos originais que lhe foram entregues, mediante recibo.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_7",
                "type": "sub_clause",
                "content": "<p><strong>Obrigações da parte CONTRATANTE:</strong></p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332175674_item_8",
                "type": "sub_clause",
                "content": "<p>fornecer à parte <strong>CONTRATADA</strong> todas as informações, documentos, provas e subsídios necessários para o bom e eficaz andamento da causa, de forma completa, verídica e tempestiva.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_9",
                "type": "sub_clause",
                "content": "<p>pagar pontualmente os honorários e reembolsar as despesas conforme estabelecido na <strong>[[REF_CLAUSE:cl_new_1771331847084]]</strong> e <strong>[[REF_CLAUSE:cl_new_1771331848012]]</strong>, sob pena de interrupção dos serviços até a regularização do débito, com as consequências legais cabíveis. </p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_10",
                "type": "sub_clause",
                "content": "<p>manter seus dados cadastrais (endereço, telefone, e-mail) atualizados junto à parte <strong>CONTRATADA</strong>, comunicando prontamente qualquer alteração. </p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_11",
                "type": "sub_clause",
                "content": "<p>comparecer aos atos processuais (audiências, perícias, depoimentos) em que sua presença for indispensável, devidamente acompanhada ou, na impossibilidade, indicar procurador com poderes específicos para tal.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_12",
                "type": "sub_clause",
                "content": "<p>dar ciência inequívoca, conforme <strong>Protocolo de Consentimento Informado [[REF_CLAUSE:cl_new_1771332176602]]</strong>, dos documentos e atos processuais relevantes apresentados pela parte <strong>CONTRATADA</strong> antes de sua protocolização, execução ou formalização.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_13",
                "type": "sub_clause",
                "content": "<p>colaborar ativamente com a parte <strong>CONTRATADA</strong>, fornecendo informações adicionais, testemunhas ou qualquer outro elemento que se mostre útil ao caso. </p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_14",
                "type": "sub_clause",
                "content": "<p>manter a guarda de seus próprios <em>backups</em> dos documentos e informações fornecidos à parte <strong>CONTRATADA</strong>, nos termos detalhados na <strong>[[REF_CLAUSE:cl_new_1771350972331]]</strong>.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_15",
                "type": "sub_clause",
                "content": "<p><strong>Dever de Colaboração e Mitigação (<em>Duty to Mitigate the Loss</em>):</strong> A parte <strong>CONTRATANTE</strong> declara-se ciente de que o sucesso da demanda depende de sua colaboração ativa. A inércia injustificada da parte <strong>CONTRATANTE</strong> em fornecer documentos, provas, ou responder às solicitações urgentes da parte <strong>CONTRATADA</strong> por prazo superior a <strong>15 (quinze) dias</strong>, autorizará a suspensão técnica dos serviços.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332175674_item_16",
                "type": "sub_clause",
                "content": "<p>Ocorrendo perda de prazos ou direitos decorrente exclusivamente da falta de resposta ou envio de documentos pela parte <strong>CONTRATANTE</strong> após devida notificação (via WhatsApp ou E-mail), a parte <strong>CONTRATADA</strong> ficará isenta de qualquer responsabilidade civil, administrativa ou ética, configurando-se culpa exclusiva da vítima e violação do dever de mitigar o próprio prejuízo.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332175674_item_transparencia_reciproca",
                "type": "sub_clause",
                "condition": "ALWAYS",
                "level": 1,
                "content": "<p><strong>Transparência Recíproca</strong>: assim como a parte <strong>CONTRATADA</strong> se compromete a comunicar à parte <strong>CONTRATANTE</strong>, sempre de forma direta e sem meios-termos, tanto os aspectos favoráveis quanto os desfavoráveis do caso, espera-se da parte <strong>CONTRATANTE</strong> a mesma postura de honestidade e completude na prestação de informações. Havendo omissão, engano ou informação inverídica por parte da <strong>CONTRATANTE</strong> que comprometa a estratégia, a defesa ou o resultado do caso, a parte <strong>CONTRATADA</strong> ficará isenta de responsabilidade civil, administrativa ou ética pelos prejuízos daí decorrentes, sujeitando-se a parte <strong>CONTRATANTE</strong>, se for o caso, às sanções por litigância de má-fé previstas nos arts. 79 a 81 da Lei n. 13.105/2015 (Código de Processo Civil) e à responsabilidade civil por perdas e danos nos termos do art. 186 da Lei n. 10.406/2002 (Código Civil).</p>"
            }
        ]
    },
    {
        "id": "cl_new_1771350955253",
        "title": "DA COMUNICAÇÃO E ATENDIMENTO",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771350955253_item_1",
                "type": "sub_clause",
                "content": "<p><strong>Validade da Comunicação Eletrônica</strong>: as partes reconhecem como meio válido e eficaz de comunicação e notificação oficial, para todos os fins deste contrato e da relação jurídica, o <strong>e-mail</strong> e o aplicativo de mensagens <strong>WhatsApp</strong> informados detalhadamente na qualificação das partes, mediante comprovação de envio e entrega.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350955253_item_2",
                "type": "sub_clause",
                "content": "<p><strong>Política de Atualização Processual</strong>: a parte <strong>CONTRATADA</strong> compromete-se a informar a parte <strong>CONTRATANTE</strong> sobre movimentações processuais ou extrajudiciais consideradas significativas.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350955253_item_3",
                "type": "sub_clause",
                "content": "<p>Entendem-se como <strong>significativas</strong> aquelas que demandam ação ou decisão imediata da parte <strong>CONTRATANTE</strong> ou que alteram substancialmente o curso da demanda como sentenças, designação de audiências, laudos periciais, decisões interlocutórias importantes e propostas de acordo.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771350955253_item_4",
                "type": "sub_clause",
                "content": "<p>não são consideradas movimentações significativas, para fins de comunicação individualizada imediata, as de caráter <strong>ordinário</strong> ou de <strong>mero andamento</strong>, tais como, mas não se limitando a: juntada de comprovantes de protocolo, abertura de conclusão ao magistrado, expedição de ofícios de rotina, ou certidões de decurso de prazo. O acompanhamento destas é responsabilidade da parte <strong>CONTRATADA</strong>, salvo pedido específico da parte <strong>CONTRATANTE</strong>.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771350955253_item_5",
                "type": "sub_clause",
                "content": "<p><strong>Acompanhamento Processual pela parte CONTRATANTE</strong>: a parte <strong>CONTRATANTE</strong> declara-se ciente de seu direito e <u>responsabilidade de acompanhar o andamento do processo diretamente nos sistemas do <strong>Poder Judiciário</strong></u>, cujo n. e link de consulta serão fornecidos pela parte <strong>CONTRATADA</strong>. Declara, ainda, estar ciente de que a parte <strong>CONTRATADA</strong> não fornecerá senhas ou acessos diretos a sistemas de terceiros ou tribunais, devendo o acompanhamento ser feito de forma autônoma pela parte <strong>CONTRATANTE</strong>, caso assim deseje, ou através dos relatórios e informações prestadas pela parte <strong>CONTRATADA</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350955253_item_6",
                "type": "sub_clause",
                "content": "<p><strong>Canal de Comunicação Contingencial e de Urgência</strong>: na hipótese de indisponibilidade técnica do <strong>Portal do Cliente</strong> (por defeito ou estar offline) ou em situações de urgência que demandem agilidade excepcional, as partes reconhecem o aplicativo de mensagens <strong>WhatsApp</strong>, nos números informados na <strong>[[REF_CLAUSE:cl_new_1771331843388]]</strong>, como canal válido para o envio e o recebimento de contrato, procuração e até mesmo a petição, além de outras minutas de peças processuais, e para a coleta do respectivo consentimento, garantindo a celeridade e a continuidade dos atos processuais.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350955253_item_7",
                "type": "sub_clause",
                "content": "<p><strong>Das Demandas Alheias ao Objeto Contratual</strong>: qualquer solicitação que não esteja diretamente relacionada ao objeto deste contrato será considerada uma <strong>nova consulta</strong>, sujeita a nova e expressa contratação de honorários.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350955253_item_8",
                "type": "sub_clause",
                "content": "<p><strong>Canais de Dúvida e Atendimento</strong>: para quaisquer dúvidas ou necessidade de informações, a parte <strong>CONTRATANTE</strong> deverá utilizar os <strong>canais oficiais de comunicação</strong> da parte <strong>CONTRATADA</strong> (e-mail, telefone/WhatsApp do escritório), observando os horários de atendimento.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771358405435",
        "title": "DA ADVOCACIA DIGITAL E PETICIONAMENTO ELETRÔNICO",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771358405435_item_1",
                "type": "sub_clause",
                "content": "<p>A parte <strong>CONTRATANTE</strong> declara-se ciente e de acordo que a atuação da parte <strong>CONTRATADA</strong> se dará, preferencialmente, por <strong>meios digitais</strong>, em conformidade com a legislação processual vigente que instituiu o processo eletrônico (<strong>Lei n. 11.419/2006 — Lei do Processo Judicial Eletrônico</strong>).</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771358405435_item_2",
                "type": "sub_clause",
                "content": "<p>Todos os atos processuais, incluindo o peticionamento, a juntada de documentos e o recebimento de intimações, serão realizados por meio dos <strong>sistemas eletrônicos dos Tribunais</strong> (ex: Projudi, E-proc, PJe), sendo as assinaturas digitais da parte <strong>CONTRATADA</strong> (via certificado digital <strong>ICP-Brasil</strong>) plenamente válidas para todos os fins de direito.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771358405435_item_3",
                "type": "sub_clause",
                "content": "<p>A parte <strong>CONTRATANTE</strong> compromete-se a fornecer documentos em formato <strong>digital legível</strong> (PDF, JPG, etc.) sempre que possível. Documentos físicos serão digitalizados conforme a política de guarda estabelecida na <strong>[[REF_CLAUSE:cl_new_1771350972331]]</strong>, e sua qualidade digital será de responsabilidade da parte <strong>CONTRATANTE</strong> após conferência.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771356860583",
        "title": "DO USO DE TECNOLOGIA E INOVAÇÃO",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771356860583_item_1",
                "type": "sub_clause",
                "content": "<p>A parte <strong>CONTRATANTE</strong> declara-se ciente e de acordo que a parte <strong>CONTRATADA</strong>, em linha com seu princípio de busca pela excelência, emprega tecnologias avançadas, incluindo sistemas de <strong>automação</strong> e ferramentas de <strong>inteligência artificial</strong> para análise de documentos e pesquisa de jurisprudência.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771356860583_item_2",
                "type": "sub_clause",
                "content": "<p>Fica estabelecido que o uso de tais tecnologias visa exclusivamente agregar valor e eficiência aos serviços, sempre com a indispensável <strong>supervisão humana qualificada</strong>, e não representará custo adicional à parte <strong>CONTRATANTE</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771350972331",
        "title": "DO TRATAMENTO E GUARDA DE DOCUMENTOS",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771350972331_item_1",
                "type": "sub_clause",
                "content": "<p><strong>Política de Gestão de Documentos – Prioridade Digital</strong>: a parte <strong>CONTRATADA</strong> adota uma política de priorização de documentos em formato digital. Todos os documentos físicos fornecidos pela parte <strong>CONTRATANTE</strong> para a instrução da causa serão digitalizados pela parte <strong>CONTRATADA</strong> para fins de arquivo eletrônico e gestão processual.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350972331_item_2",
                "type": "sub_clause",
                "content": "<p><strong>Política \"Zero Documentos Físicos\"</strong>: após a digitalização, os documentos físicos originais não serão retidos pela parte <strong>CONTRATADA</strong>. A responsabilidade pela guarda dos documentos físicos originais, após sua digitalização e conferência, pertencerá exclusivamente à parte <strong>CONTRATANTE</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350972331_item_3",
                "type": "sub_clause",
                "content": "<p><strong>Prazo para Retirada de Documentos Físicos</strong>: a parte <strong>CONTRATANTE</strong> deverá retirar os documentos físicos originais no prazo máximo de <strong>30 (trinta) dias úteis</strong>, contados da data da solicitação de retirada feita pela parte <strong>CONTRATADA</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350972331_item_4",
                "type": "sub_clause",
                "content": "<p><strong>Consequências da Não Retirada</strong>: a não retirada dos documentos físicos originais dentro do prazo estipulado no item anterior desta cláusula autorizará a parte <strong>CONTRATADA</strong> a realizar o descarte seguro dos mesmos, sem que isso gere qualquer ônus ou responsabilidade por parte da <strong>CONTRATADA</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350972331_item_5",
                "type": "sub_clause",
                "content": "<p><strong>Eliminação/Anonimização de Dados Pessoais</strong>: findo o mandato e transcorridos os prazos legais de prescrição para quaisquer ações de responsabilidade (especialmente os prazos previstos na <strong>Lei n. 10.406/2002 (Código Civil)</strong> e na <strong>Lei n. 8.906/1994 (Estatuto da Advocacia)</strong>), os dados pessoais da parte <strong>CONTRATANTE</strong> serão eliminados ou anonimizados de forma segura dos sistemas da parte <strong>CONTRATADA</strong>, exceto aqueles cuja manutenção seja exigida por lei ou regulamentação (ex: para fins fiscais, ou para cumprimento de ordem judicial), em conformidade com a <strong>Lei n. 13.709/2018 (LGPD)</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350972331_item_6",
                "type": "sub_clause",
                "content": "<p><strong>Responsabilidade por <em>Backups</em> da parte CONTRATANTE</strong>: é de exclusiva responsabilidade da parte <strong>CONTRATANTE</strong> manter seus próprios <em>backups</em> e cópias de segurança de todos os documentos, informações e dados fornecidos à parte <strong>CONTRATADA</strong>, bem como de quaisquer atualizações processuais que receba diretamente de outras fontes. A parte <strong>CONTRATADA</strong> é responsável pela gestão da versão digital do processo em seus sistemas, mas não pela guarda física ou pelo <em>backup</em> primário da parte <strong>CONTRATANTE</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771332176602",
        "title": "DO PROTOCOLO DE CONSENTIMENTO INFORMADO",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771332176602_item_1",
                "type": "sub_clause",
                "content": "<p><strong>Identificação do Ato Relevante</strong>: a parte <strong>CONTRATADA</strong>, em sua diligência profissional, identificará qualquer ato processual ou extrajudicial (ex.: minuta de petição inicial, contestação, recurso, proposta de acordo, desistência de ação, acordo extrajudicial, parecer conclusivo, termos de ajuste de conduta) que, por sua natureza e potenciais consequências jurídicas, exija a ciência e aprovação expressa e prévia da parte <strong>CONTRATANTE</strong> (ou seu(sua) representante legal/procurador(a), conforme o caso).</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332176602_item_2",
                "type": "sub_clause",
                "content": "<p><strong>Disponibilização e Notificação</strong>: o documento ou a informação detalhada sobre o ato relevante será disponibilizado à parte <strong>CONTRATANTE</strong> (ou seu(sua) representante legal/procurador(a), conforme o caso) no <strong>Portal do Cliente</strong> Rodrigo Demeterco Advocacia (www.rodrigodemeterco.adv.br). Simultaneamente, será notificada da disponibilização através do <strong>e-mail</strong> e o aplicativo de mensagens <strong>WhatsApp</strong> informados detalhadamente na qualificação das partes, mediante comprovação de envio e entrega.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332176602_item_3",
                "type": "sub_clause",
                "content": "<p><strong>Manifestação de Ciência e Aprovação</strong>: a parte <strong>CONTRATANTE</strong> (ou seu(sua) representante legal/procurador(a), conforme o caso) deverá acessar o documento no <strong>Portal do Cliente</strong>, visualizá-lo em sua integralidade e, após leitura e compreensão completas, clicar no botão \"DAR CIÊNCIA E APROVAR\" ou funcionalidade equivalente. Este ato eletrônico: </p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332176602_item_4",
                "type": "sub_clause",
                "content": "<p>gerará um registro eletrônico indelével de data, hora e IP de acesso no sistema em seu banco de dados oficial, vinculado ao documento específico e à identificação da usuária que realizou a ação</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332176602_item_5",
                "type": "sub_clause",
                "content": "<p>servirá como comprovação formal e inequívoca da ciência e aprovação sobre o conteúdo do documento e o ato correlato, bem como representará a autorização expressa para a parte <strong>CONTRATADA</strong> prosseguir com o ato.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332176602_item_6",
                "type": "sub_clause",
                "content": "<p>A ciência será obtida preferencialmente através do <strong>Portal do Cliente</strong>. Em situações de impossibilidade técnica ou urgência excepcional, a ciência poderá ser formalizada por e-mail com confirmação de leitura ou mensagem de WhatsApp com confirmação de ciência por escrito.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332176602_item_7",
                "type": "sub_clause",
                "content": "<p><strong>Consequências da Ausência de Ciência ou Recusa</strong>: a ausência de manifestação da parte <strong>CONTRATANTE</strong> (ou seu(sua) representante legal/procurador(a), conforme o caso) no prazo de <strong>24 (vinte e quatro) horas</strong> (para atos de urgência e/ou aqueles com prazo legal definido) ou no prazo expressamente comunicado pela parte <strong>CONTRATADA</strong> na notificação, ou a recusa injustificada em aprovar o ato, poderá implicar na não prática do ato pela parte <strong>CONTRATADA</strong>, que ficará desonerada de qualquer responsabilidade por eventuais prejuízos.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332176602_item_8",
                "type": "sub_clause",
                "content": "<p><strong>Blindagem e Prova</strong>: todos os registros de ciência e aprovação serão armazenados de forma segura e auditável em seu banco de dados oficial para fins de prova e blindagem jurídica.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771350871517",
        "title": "DA CONFORMIDADE COM A LEI GERAL DE PROTEÇÃO DE DADOS (LGPD)",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771350871517_item_1",
                "type": "sub_clause",
                "content": "<p><strong>Da Base Legal do Tratamento</strong>: O tratamento dos dados pessoais da parte <strong>CONTRATANTE</strong> (incluindo dados sensíveis necessários à instrução probatória) realizado pela parte <strong>CONTRATADA</strong> <strong>independe de consentimento</strong>, fundamentando-se estritamente nas hipóteses legais de <strong>Execução de Contrato</strong> (art. 7º, V, da Lei n. 13.709/2018 — LGPD) e <strong>Exercício Regular de Direitos em Processo Judicial, Administrativo ou Arbitral</strong> (art. 7º, VI, da Lei n. 13.709/2018 — LGPD), garantindo-se a segurança jurídica da defesa técnica.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350871517_item_2",
                "type": "sub_clause",
                "content": "<p>O tratamento de dados abrange a coleta, armazenamento, utilização e compartilhamento dos dados estritamente necessários para a elaboração de peças processuais, comunicação com o Poder Judiciário e outras partes envolvidas, e para a defesa dos interesses da parte <strong>CONTRATANTE</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350871517_item_3",
                "type": "sub_clause",
                "content": "<p>A parte <strong>CONTRATADA</strong> se compromete a adotar todas as medidas técnicas e administrativas para proteger os dados pessoais contra acessos não autorizados e situações de destruição, perda ou alteração, em conformidade com a <strong>Lei n. 13.709/2018 (LGPD)</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771350871517_item_4",
                "type": "sub_clause",
                "content": "<p>A parte <strong>CONTRATANTE</strong> declara-se ciente de seus direitos como titular dos dados, incluindo o direito de acesso, retificação, eliminação e portabilidade, que poderão ser exercidos mediante solicitação formal à parte <strong>CONTRATADA</strong>.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771332178162",
        "title": "DA VALIDADE DA ASSINATURA ELETRÔNICA",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771332178162_item_1",
                "type": "sub_clause",
                "content": "<p><strong>Reconhecimento da Validade Legal</strong>: As partes reconhecem expressamente a validade jurídica, força probatória e eficácia de todas as assinaturas eletrônicas ou digitais apostas neste contrato, bem como em quaisquer documentos gerados ou trocados eletronicamente no curso da relação contratual.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332178162_item_2",
                "type": "sub_clause",
                "content": "<p><strong>Definição de Assinatura Eletrônica</strong>: Para os fins deste contrato, \"assinatura eletrônica\" compreende os dados em formato eletrônico que se ligam ou associam a outros dados em formato eletrônico e que são utilizados pelo signatário para assinar, incluindo:</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332178162_item_3",
                "type": "sub_clause",
                "content": "<p><strong>Assinatura Eletrônica Simples</strong>: Dados que permitam identificar o signatário e que são anexados ou associados a outros dados em formato eletrônico do signatário (ex: login e senha, código de acesso por e-mail/SMS). </p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332178162_item_4",
                "type": "sub_clause",
                "content": "<p><strong>Assinatura Eletrônica Avançada</strong>: Aquela que está associada ao signatário de forma unívoca, utiliza dados para a criação de assinatura eletrônica que o signatário pode, com elevado nível de confiança, usar sob o seu controlo exclusivo, e é ligada aos dados a que se refere de tal modo que qualquer alteração subsequente seja detetável.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332178162_item_5",
                "type": "sub_clause",
                "content": "<p><strong>Assinatura Eletrônica Qualificada (Assinatura Digital)</strong>: Aquela que é criada por um certificado digital emitido por uma Autoridade Certificadora credenciada na Infraestrutura de Chaves Públicas Brasileira (ICP-Brasil).</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332178162_item_6",
                "type": "sub_clause",
                "content": "<p><strong>Legislação Aplicável e Dispensa de Testemunhas</strong>: Esta validade é garantida nos termos da legislação brasileira, em especial: </p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332178162_item_7",
                "type": "sub_clause",
                "content": "<p><strong>Medida Provisória n. 2.200-2/2001</strong>: Que instituiu a ICP-Brasil e garantiu a validade jurídica dos documentos eletrônicos. </p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332178162_item_8",
                "type": "sub_clause",
                "content": "<p><strong>Lei n. 14.063/2020</strong>: Que dispõe sobre o uso de assinaturas eletrônicas nas interações com entes públicos, mas serve de baliza para as relações privadas.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332178162_item_9",
                "type": "sub_clause",
                "content": "<p><strong>Lei n. 14.620/2023</strong>: Nos termos do art. 784, § 4º, da Lei n. 13.105/2015 (Código de Processo Civil), incluído pela Lei n. 14.620/2023, as partes reconhecem expressamente que este contrato eletrônico constitui <strong>Título Executivo Extrajudicial</strong> de plena eficácia, sendo <strong>legalmente dispensada a assinatura de testemunhas</strong> quando sua integridade for conferida por provedor de assinatura qualificada ou avançada (ex: Clicksign/Gov.br). </p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332178162_item_10",
                "type": "sub_clause",
                "content": "<p><strong>Lei n. 10.406/2002 (Código Civil) e Lei n. 13.105/2015 (Código de Processo Civil)</strong>: Que admitem a utilização de todos os meios de prova moralmente legítimos para comprovar os fatos, nos quais o instrumento particular se enquadra.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332178162_item_11",
                "type": "sub_clause",
                "content": "<p><strong>Força Probatória</strong>: A assinatura eletrônica, especialmente a qualificada (digital), possui a mesma força probante da assinatura física em papel, invertendo-se o ônus da prova em caso de contestação de sua autenticidade.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771332194057",
        "title": "DA FORÇA MAIOR E DO CASO FORTUITO",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771332194057_item_1",
                "type": "sub_clause",
                "content": "<p>Nenhuma das partes será responsável por quaisquer falhas ou atrasos no cumprimento de suas obrigações contratuais se tais falhas ou atrasos forem causados por eventos de <strong>Força Maior</strong> ou <strong>Caso Fortuito</strong>, conforme definidos pela legislação brasileira (<strong>art. 393 da Lei n. 10.406/2002 — Código Civil</strong>), que estejam fora do controle razoável das partes e que não poderiam ter sido evitados com diligência.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332194057_item_2",
                "type": "sub_clause",
                "content": "<p>A parte afetada por um evento de <strong>Força Maior</strong> ou <strong>Caso Fortuito</strong> deverá notificar a outra parte por escrito o mais breve possível sobre a ocorrência e a provável duração de tal evento.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332194057_item_3",
                "type": "sub_clause",
                "content": "<p>Durante o período de vigência de evento de <strong>Força Maior</strong> ou <strong>Caso Fortuito</strong>, as obrigações da parte afetada ficarão suspensas. Caso o evento persista por período superior a <strong>30 (trinta) dias</strong>, as partes deverão negociar de boa-fé uma solução para mitigar os impactos ou, alternativamente, o contrato poderá ser rescindido por qualquer das partes, assegurado o pagamento pelos serviços já prestados até a data da ocorrência do evento.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771332194792",
        "title": "DA RESCISÃO DO CONTRATO",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771332194792_item_1",
                "type": "sub_clause",
                "content": "<p>O presente contrato poderá ser rescindido por qualquer das partes, a qualquer tempo, mediante comunicação escrita com antecedência mínima de <strong>15 (quinze) dias</strong>, salvo em caso de justa causa.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332194792_item_2",
                "type": "sub_clause",
                "content": "<p><strong>Rescisão por iniciativa da parte CONTRATANTE sem justa causa</strong>: A revogação unilateral do mandato por parte da <strong>CONTRATANTE</strong> não a isenta do pagamento pelos serviços já prestados. Nesta hipótese, para fins de cálculo dos <strong>Honorários Proporcionais (Pro Rata)</strong> devidos imediatamente, as partes convencionam a seguinte Escala de Marcos Processuais, incidente sobre o valor atualizado da causa ou do proveito econômico perseguido:</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332194792_item_3",
                "type": "sub_clause",
                "content": "<p><strong>Fase 1 (Estudo e Peticionamento):</strong> Será devido <strong>30% (trinta por cento)</strong> dos honorários totais contratados caso a rescisão ocorra após o atendimento inicial, análise de provas e protocolo da Petição Inicial ou Defesa.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332194792_item_4",
                "type": "sub_clause",
                "content": "<p><strong>Fase 2 (Saneamento e Instrução):</strong> Será devido o acumulado de <strong>60% (sessenta por cento)</strong> caso a rescisão ocorra após a apresentação de Réplica, especificação de provas ou realização de audiências de conciliação/instrução.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332194792_item_5",
                "type": "sub_clause",
                "content": "<p><strong>Fase 3 (Sentença de 1º Grau):</strong> Será devido o acumulado de <strong>80% (oitenta por cento)</strong> caso a rescisão ocorra após a apresentação de Memoriais ou obtenção da sentença de mérito.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332194792_item_6",
                "type": "sub_clause",
                "content": "<p><strong>Fase 4 (Fase Recursal):</strong> Será devido o acumulado de <strong>100% (cem por cento)</strong> caso a rescisão ocorra após a interposição de recursos ou contrarrazões ao Tribunal de Justiça.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332194792_item_7",
                "type": "sub_clause",
                "content": "<p><strong>Ressarcimento de Despesas de Desmobilização:</strong> Sem prejuízo do pagamento proporcional acima (que remunera o trabalho técnico já realizado), a parte <strong>CONTRATANTE</strong> ressarcirá a parte <strong>CONTRATADA</strong> pelas despesas administrativas comprovadamente incorridas em razão da desmobilização do caso, mediante apresentação de demonstrativo detalhado, vedada a cobrança de multa ou penalidade pela revogação em si, nos termos da jurisprudência pacífica do Superior Tribunal de Justiça sobre a inexigibilidade de cláusula penal por revogação unilateral de mandato.</p>",
                "condition": "ALWAYS",
                "level": 1
            },
            {
                "id": "cl_new_1771332194792_item_8",
                "type": "sub_clause",
                "content": "<p><strong>Rescisão por iniciativa da parte CONTRATADA sem justa causa</strong>: em caso de renúncia do mandato nos contratos de honorários de êxito puro (<em>Ad Exitum</em>), não haverá valores a serem devolvidos à parte <strong>CONTRATANTE</strong>, uma vez que não foram pagos honorários iniciais, sendo a remuneração proporcional ao trabalho já prestado considerada coberta pela expectativa dos honorários de êxito, caso houvesse sucesso na demanda até o momento da renúncia. Nas demais modalidades de honorários (fixo, misto, partido ou por hora), a parte <strong>CONTRATADA</strong> deverá restituir à parte <strong>CONTRATANTE</strong> a parcela proporcional aos serviços ainda não prestados até a data da renúncia, calculada com base no estágio de execução do mandato.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332194792_item_9",
                "type": "sub_clause",
                "content": "<p><strong>Rescisão por Justa Causa</strong>: ocorre pelo descumprimento de qualquer cláusula (a título de exemplo: a recusa em fornecer documentos essenciais após notificação, a prática de ato ilícito que prejudique a defesa, ou a violação do dever de lealdade e boa-fé). Em caso de justa causa imputável à parte <strong>CONTRATANTE</strong>, a parte <strong>CONTRATADA</strong> poderá rescindir imediatamente o contrato, sendo devidos os honorários integrais pactuados neste instrumento, calculados com base no Proveito Econômico, conforme definido na <strong>[[REF_CLAUSE:cl_new_1771331845468]]</strong> deste contrato, a título de perdas e danos decorrentes do inadimplemento contratual, nos termos do <strong>art. 389 da Lei n. 10.406/2002 (Código Civil)</strong>, sem prejuízo de outras medidas cabíveis.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771332196280",
        "title": "DA SOLUÇÃO DE CONFLITOS E FORO",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_1771332196280_item_1",
                "type": "sub_clause",
                "content": "<p><strong>Mediação Prévia Obrigatória</strong>: qualquer controvérsia, divergência ou disputa oriunda ou relacionada ao presente contrato ou à prestação de serviços advocatícios será submetida, primeiramente, a um procedimento de <strong>mediação extrajudicial</strong>, administrado por câmara privada ou mediador independente, como condição de procedibilidade para qualquer eventual ação judicial. As custas da mediação serão divididas igualmente entre as partes, salvo acordo em contrário.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332196280_item_2",
                "type": "sub_clause",
                "content": "<p><strong>Foro de Eleição</strong>: <strong>Restando infrutífera a mediação ou conciliação prevista no item anterior</strong>, e em estrita observância ao art. 63 da Lei n. 13.105/2015 (Código de Processo Civil), com a redação dada pela Lei n. 14.879/2024, as partes elegem o foro da Comarca do <strong>domicílio da parte CONTRATANTE</strong> (ou, subsidiariamente, o foro onde a obrigação principal deve ser satisfeita) como competente para dirimir quaisquer litígios oriundos deste contrato. Esta eleição visa facilitar a defesa do consumidor e prestigiar a realização dos atos por meio do Juízo 100% Digital, renunciando a qualquer outro por mais privilegiado que seja.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    },
    {
        "id": "cl_new_1771332197840",
        "title": "DAS DISPOSIÇÕES FINAIS",
        "type": "clause",
        "tags": [
            "Universal"
        ],
        "condition": "ALWAYS",
        "children": [
            {
                "id": "cl_new_vigencia_add",
                "type": "sub_clause",
                "condition": "ALWAYS",
                "level": 0,
                "content": "<p><strong>Vigência</strong>: O presente contrato vigora por prazo indeterminado, iniciando-se na data de sua assinatura e permanecendo válido até a conclusão dos serviços contratados ou até sua rescisão, nos termos da <strong>[[REF_CLAUSE:cl_new_1771332194792]]</strong>, o que ocorrer primeiro.</p>"
            },
            {
                "id": "cl_new_1771332197840_item_1",
                "type": "sub_clause",
                "content": "<p>O presente contrato é celebrado em caráter <strong>formal e vinculante</strong> entre as partes, obrigando-as e seus sucessores a qualquer título.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332197840_item_2",
                "type": "sub_clause",
                "content": "<p>Qualquer tolerância não implicará em novação, transação, renúncia de direitos ou precedente para descumprimento.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332197840_item_3",
                "type": "sub_clause",
                "content": "<p>Este instrumento revoga e substitui quaisquer acordos prévios.</p>",
                "condition": "ALWAYS",
                "level": 0
            },
            {
                "id": "cl_new_1771332197840_item_4",
                "type": "sub_clause",
                "content": "<p>As partes declaram ter lido e compreendido todas as cláusulas e condições deste contrato.</p>",
                "condition": "ALWAYS",
                "level": 0
            }
        ]
    }
];
